import { z } from 'zod'

export const PlaceSortKeySchema = z.enum([
  'accessControl',
  'address',
  'createdAt',
  'features',
  'name',
  'phone',
  'pms',
  'status',
  'timezone',
])

export const PlaceSortKey = PlaceSortKeySchema.enum

export type PlaceSortKey = z.infer<typeof PlaceSortKeySchema>
